/**
 * Tree View Component
 * CoreUI Bootstrap uyumlu tree view bileşeni
 */
class TreeView {
  constructor(containerId, data) {
    // console.log('TreeView constructor çağrıldı:', containerId, data);
    this.containerId = containerId;
    this.container = document.getElementById(containerId);
    // console.log('Container element:', this.container);
    this.data = data;
    this.selectedItem = null;
    this.expandedItems = new Set();
    this.render();
  }
  
  render() {
    // console.log('Render method çağrıldı, container:', this.container, 'data:', this.data);
    
    if (!this.container) {
      console.error('Tree container bulunamadı:', this.containerId);
      return;
    }
    
    if (!this.data || !Array.isArray(this.data) || this.data.length === 0) {
      console.warn('Tree data boş veya geçersiz:', this.data);
      this.container.innerHTML = '<li class="tree-item"><div class="tree-item-content text-warning"><i class="fas fa-info-circle tree-icon"></i><span>Veri bulunamadı</span></div></li>';
      return;
    }
    
    this.container.innerHTML = '';
    this.data.forEach((item, index) => {
      // console.log(`Tree item ${index} oluşturuluyor:`, item);
      const treeItem = this.createTreeItem(item);
      this.container.appendChild(treeItem);
    });
    
    // console.log('Render tamamlandı, container içeriği:', this.container.innerHTML);
  }
  
  createTreeItem(item) {
    const li = document.createElement('li');
    li.className = 'tree-item';
    li.setAttribute('data-id', item.id);
    
    const content = document.createElement('div');
    content.className = 'tree-item-content';
    
    // Toggle button for expandable items
    // Fix: Only show toggle if children is a non-empty array OR boolean true (lazy load)
    // Empty arrays [] should NOT have a toggle button
    const hasChildren = item.children && (!Array.isArray(item.children) || item.children.length > 0);

    if (hasChildren) {
      const toggle = document.createElement('button');
      toggle.className = 'tree-toggle';
      toggle.innerHTML = '<i class="fas fa-chevron-right"></i>';
      toggle.onclick = (e) => {
        e.stopPropagation();
        this.toggleExpand(li, item);
      };
      content.appendChild(toggle);
    } else {
      const spacer = document.createElement('div');
      spacer.style.width = '20px';
      spacer.style.marginRight = '5px';
      content.appendChild(spacer);
    }
    
    // Icon
    const icon = document.createElement('i');
    icon.className = item.icon || 'fas fa-file';
    icon.classList.add('tree-icon');
    content.appendChild(icon);
    
    // Text
    const text = document.createElement('span');
    text.textContent = item.text;
    content.appendChild(text);
    
    /* [COMM-STATUS] COMM Durumu gostergesi (gizli baslar, applyCommStatusToTree acar) */
    const commBadge = document.createElement('span');
    commBadge.className = 'comm-error-badge';
    commBadge.innerHTML = '<i class="fas fa-exclamation" style="font-size:0.55rem"></i>';
    commBadge.title = '';
    content.appendChild(commBadge);
    /* [/COMM-STATUS] */
    
    /* [TEST-MODE] Flask icon = test modu */
    if (item.icon === 'fas fa-flask') {
      content.classList.add('test-mode-active');
      icon.title = 'Test Modu - Bu sayfa test ediliyor';
      const testLabel = document.createElement('span');
      testLabel.className = 'test-mode-label';
      testLabel.textContent = 'TEST';
      content.appendChild(testLabel);
    }
    /* [/TEST-MODE] */
    
    // Click handler for selection
    content.onclick = () => this.selectItem(item, content);
    
    li.appendChild(content);
    
    // Auto-expand if state.opened is true
    if (item.state && item.state.opened && hasChildren) {
        // Use setTimeout to ensure DOM update cycle (optional but safer)
        // or call directly if we trust the synchronous DOM creation
        this.toggleExpand(li, item);
    }

    return li;
  }
  
  toggleExpand(li, item) {
    // Use :scope > ... to ensure we only select direct children if supported, 
    // or be more specific to avoid selecting descendants' elements.
    // However, since children are inside .tree-children container, 
    // querySelector('.tree-children') on li will find the direct container first.
    const existingChildren = li.querySelector('.tree-children');
    
    // Find the toggle icon specifically within the item content div of this li
    // This prevents finding icons in nested children
    const contentDiv = li.querySelector('.tree-item-content');
    const toggle = contentDiv ? contentDiv.querySelector('.tree-toggle i') : null;
    
    if (!toggle) return;
    
    // console.log('Toggle expand:', item.text, 'Existing children:', !!existingChildren);

    if (existingChildren) {
      // Toggle existing children
      if (existingChildren.classList.contains('expanded')) {
        // console.log('Collapsing...');
        existingChildren.classList.remove('expanded');
        existingChildren.style.display = 'none'; // Force hide
        toggle.className = 'fas fa-chevron-right';
        this.expandedItems.delete(item.id);
      } else {
        // console.log('Expanding...');
        existingChildren.classList.add('expanded');
        existingChildren.style.display = 'block'; // Force show
        toggle.className = 'fas fa-chevron-down';
        this.expandedItems.add(item.id);
      }
    } else if (item.children) {
      // Check if children are already loaded in data
      if (Array.isArray(item.children)) {
          const childrenContainer = document.createElement('ul');
          childrenContainer.className = 'tree-children expanded';
          
          item.children.forEach(childItem => {
            childrenContainer.appendChild(this.createTreeItem(childItem));
          });
          
          li.appendChild(childrenContainer);
          toggle.className = 'fas fa-chevron-down';
          this.expandedItems.add(item.id);
      } else {
          // Load children for the first time (Lazy Load simulation)
          toggle.className = 'fas fa-spinner fa-spin';
          
          // Simulate API call with delay
          setTimeout(() => {
            const childrenContainer = document.createElement('ul');
            childrenContainer.className = 'tree-children expanded';
            
            // Generate child items (burada gerçek API çağrısı yapılabilir)
            const childItems = this.generateChildItems(item);
            childItems.forEach(childItem => {
              childrenContainer.appendChild(this.createTreeItem(childItem));
            });
            
            li.appendChild(childrenContainer);
            toggle.className = 'fas fa-chevron-down';
            this.expandedItems.add(item.id);
          }, 500);
      }
    }
  }
  
  generateChildItems(parentItem) {
    // Demo child items - gerçek uygulamada API'den gelecek
    const childItems = [
      {
        id: parentItem.id + '_alt1',
        text: 'Alt Departman 1',
        icon: 'fas fa-building',
        children: true,
        original: {
          parentId: parentItem.id,
          target: parentItem.original.target + '01',
          title: 'Alt Departman 1'
        },
        state: {
          opened: false
        }
      },
      {
        id: parentItem.id + '_alt2',
        text: 'Alt Departman 2',
        icon: 'fas fa-building',
        children: true,
        original: {
          parentId: parentItem.id,
          target: parentItem.original.target + '02',
          title: 'Alt Departman 2'
        },
        state: {
          opened: false
        }
      },
      {
        id: parentItem.id + '_personel1',
        text: 'Personel Listesi',
        icon: 'fas fa-users',
        children: false,
        original: {
          parentId: parentItem.id,
          target: parentItem.original.target + 'personel',
          title: 'Personel Listesi'
        },
        state: {
          opened: false
        }
      },
      {
        id: parentItem.id + '_rapor1',
        text: 'Raporlar',
        icon: 'fas fa-chart-bar',
        children: false,
        original: {
          parentId: parentItem.id,
          target: parentItem.original.target + 'rapor',
          title: 'Raporlar'
        },
        state: {
          opened: false
        }
      }
    ];
    
    return childItems;
  }
  
  selectItem(item, element) {
    // Remove previous selection
    const prevSelected = this.container.querySelector('.tree-item-content.selected');
    if (prevSelected) {
      prevSelected.classList.remove('selected');
    }
    
    // Add selection to current item
    element.classList.add('selected');
    this.selectedItem = item;
    
    // Update details panel
    this.updateDetailsPanel(item);
    
    // Trigger custom event
    const selectEvent = new CustomEvent('treeItemSelected', {
      detail: { item: item }
    });
    document.dispatchEvent(selectEvent);
  }
  
  updateDetailsPanel(item) {
    const detailsPanel = document.getElementById('selectedItemDetails');
    if (detailsPanel) {
      detailsPanel.innerHTML = `
        <div class="card">
          <div class="card-header">
            <h6 class="mb-0"><i class="${item.icon}"></i> ${item.text}</h6>
          </div>
          <div class="card-body">
            <table class="table table-sm">
              <tr>
                <td><strong>ID:</strong></td>
                <td>${item.id}</td>
              </tr>
              <tr>
                <td><strong>Icon:</strong></td>
                <td><i class="${item.icon}"></i> ${item.icon}</td>
              </tr>
              <tr>
                <td><strong>Alt Öğeler:</strong></td>
                <td>${item.children ? '<span class="badge bg-success">Var</span>' : '<span class="badge bg-secondary">Yok</span>'}</td>
              </tr>
              <tr>
                <td><strong>Parent ID:</strong></td>
                <td>${item.original.parentId}</td>
              </tr>
              <tr>
                <td><strong>Target:</strong></td>
                <td><code>${item.original.target}</code></td>
              </tr>
              <tr>
                <td><strong>Durum:</strong></td>
                <td>${item.state?.opened ? '<span class="badge bg-info">Açık</span>' : '<span class="badge bg-warning">Kapalı</span>'}</td>
              </tr>
            </table>
            <div class="mt-3">
              <button class="btn btn-primary btn-sm" onclick="editItem('${item.id}')">
                <i class="fas fa-edit"></i> Düzenle
              </button>
              <button class="btn btn-info btn-sm" onclick="viewDetails('${item.id}')">
                <i class="fas fa-eye"></i> Detaylar
              </button>
              ${item.children ? `
                <button class="btn btn-success btn-sm" onclick="addChild('${item.id}')">
                  <i class="fas fa-plus"></i> Alt Öğe Ekle
                </button>
              ` : ''}
            </div>
          </div>
        </div>
      `;
    }
  }
  
  // Utility methods
  findItemById(id, items = this.data) {
    for (let item of items) {
      if (item.id === id) {
        return item;
      }
      // Search in children if expanded
      if (this.expandedItems.has(item.id) && item.children) {
        const childItems = this.generateChildItems(item);
        const found = this.findItemById(id, childItems);
        if (found) return found;
      }
    }
    return null;
  }
  
  expandPath(targetId) {
    // Bu method belirli bir ID'ye ulaşmak için gerekli path'i açar
    // Implementasyon gerektiğinde eklenebilir
  }
}

// Global utility functions
function editItem(itemId) {
  console.log('Edit item:', itemId);
  // Burada düzenleme modal'ı açılabilir
  alert('Düzenleme özelliği yakında eklenecek: ' + itemId);
}

function viewDetails(itemId) {
  console.log('View details:', itemId);
  // Burada detay modal'ı açılabilir
  alert('Detay görüntüleme özelliği yakında eklenecek: ' + itemId);
}

function addChild(parentId) {
  console.log('Add child to:', parentId);
  // Burada yeni öğe ekleme modal'ı açılabilir
  alert('Alt öğe ekleme özelliği yakında eklenecek: ' + parentId);
}

// Tree view instances
let sidebarTree, mainTree;

// Initialize tree views when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM yüklendi, tree view başlatılıyor...');
  
  // Fallback test data
  const testData = [
    {
      "id": "101",
      "text": "PAMUKOVA",
      "children": true,
      "icon": "fas fa-folder",
      "state": {
        "opened": false
      },
      "original": {
        "parentId": 101,
        "target": "10000",
        "title": "PAMUKOVA"
      }
    },
    {
      "id": "102", 
      "text": "BURGAZ",
      "children": true,
      "icon": "fas fa-folder",
      "state": {
        "opened": false
      },
      "original": {
        "parentId": 102,
        "target": "10000", 
        "title": "BURGAZ"
      }
    },
    {
      "id": "103",
      "text": "KARAMAN",
      "children": true,
      "icon": "fas fa-folder",
      "state": {
        "opened": false
      },
      "original": {
        "parentId": 103,
        "target": "10000",
        "title": "KARAMAN"
      }
    }
  ];
  
  // [PAGE-BLACKLIST] Kullanıcıya özel sayfa kara listesini yükle.
  // page-blacklist.json yapısı: { "<userId>": { "<pageId>": true, ... }, ... }
  // Sonuç olarak window.__pageBlacklistSet = Set<string> (kullanıcının yasak parentId'leri)
  async function loadUserPageBlacklist() {
    try {
      const userInfo = (typeof getUserInfo === 'function') ? getUserInfo() : null;
      if (!userInfo) {
        window.__pageBlacklistSet = new Set();
        return;
      }
      // Super admin/admin ise blacklist uygulanmaz
      const role = (userInfo.role || userInfo.Role || '').toLowerCase();
      if (role === 'super_admin' || role === 'admin') {
        window.__pageBlacklistSet = new Set();
        window.__pageBlacklistRole = role;
        return;
      }
      const userId = String(userInfo.user_id || userInfo.id || userInfo.UserId || '');
      if (!userId) { window.__pageBlacklistSet = new Set(); return; }

      const res = await fetch('/admin/api/page-blacklist', {
        headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') }
      });
      if (!res.ok) { window.__pageBlacklistSet = new Set(); return; }
      const data = await res.json();
      const userMap = (data && data[userId]) || {};
      const banned = Object.keys(userMap).filter(k => userMap[k] === true).map(String);
      window.__pageBlacklistSet = new Set(banned);
      console.log(`[PageBlacklist] Kullanici ${userId} icin ${banned.length} sayfa engelli`);
    } catch (e) {
      console.warn('[PageBlacklist] Yuklenemedi:', e.message);
      window.__pageBlacklistSet = new Set();
    }
  }

  // Tree'den blacklist'teki node'ları çıkar (recursive). Eşleşme: data.parentId veya id
  function pruneBlacklistedNodes(nodes) {
    const banned = window.__pageBlacklistSet || new Set();
    if (!banned.size || !Array.isArray(nodes)) return nodes;
    return nodes.filter(node => {
      const navId = node.data && node.data.parentId != null ? String(node.data.parentId) : null;
      const nid = node.id != null ? String(node.id) : null;
      if ((navId && banned.has(navId)) || (nid && banned.has(nid))) {
        return false; // bu düğüm engelli
      }
      if (Array.isArray(node.children) && node.children.length > 0) {
        node.children = pruneBlacklistedNodes(node.children);
      }
      return true;
    });
  }

  // Try to load from API first, then local JSON with cache busting, fallback to test data
  async function loadTreeData() {
    // Önce blacklist'i yükle (paralel başlat)
    const blacklistPromise = loadUserPageBlacklist();
    try {
      // 1. API API (Dynamic)
      console.log('Fetching tree data from API...');
      const apiRes = await fetch('/api/v1/tree-data');
      if (apiRes.ok) {
        const data = await apiRes.json();
        console.log('Tree data loaded from API', data.length);
        await blacklistPromise;
        initTrees(data);
        return;
      }
    } catch (e) {
      console.warn('API fetch failed, trying static file...', e);
    }

    // 2. Static File (Cache Busted)
    try {
      const ts = Date.now();
      const res = await fetch(`assets/data/tree-data.json?t=${ts}`);
      if (!res.ok) throw new Error('Static file not found');
      const data = await res.json();
      console.log('Tree data loaded from static file', data.length);
      await blacklistPromise;
      initTrees(data);
    } catch (err) {
      console.error('All tree data sources failed:', err);
      // initTrees(testData); // Optional: use test data as last resort
      const sidebarId = document.getElementById('sidebarTree') ? 'sidebarTree' : 'treeView';
      const container = document.getElementById(sidebarId);
      if(container) container.innerHTML = '<li class="tree-item"><div class="tree-item-content text-danger"><i class="fas fa-exclamation-triangle tree-icon"></i><span>Veri yüklenemedi</span></div></li>';
    }
  }

  loadTreeData();

  function initTrees(data) {

    // Filter data based on user permission
    if (typeof getUserInfo === 'function') {
        const userInfo = getUserInfo();
        console.log('TreeView: User Info:', userInfo); // DEBUG LOG

        // Check for both lowercase and PascalCase property names
        const permission = userInfo ? (userInfo.group_permission || userInfo.GroupPermission) : null;

        if (permission) {
            const permissionId = String(permission);
            console.log('Filtering tree for permission:', permissionId);
            
            // 1. Priority: Find single node by ID or parentId (e.g. MEMORIAL node for 10109)
            // This ensures we show the parent container and all its siblings/children correctly
            function findNode(nodes, id) {
                if (!nodes || !Array.isArray(nodes)) return null;
                for (const node of nodes) {
                    // Check against id OR data.parentId
                    if (String(node.id) === id || (node.data && String(node.data.parentId) === id)) {
                        return node;
                    }
                    if (node.children && Array.isArray(node.children)) {
                        const found = findNode(node.children, id);
                        if (found) return found;
                    }
                }
                return null;
            }

            const allowedNode = findNode(data, permissionId);
            
            if (allowedNode) {
                console.log('Found allowed node by ID/parentId:', allowedNode);
                
                // User Request: "Main kismi kayboldu" -> Show the node itself.
                // "Main Expend olarak gelsin" -> Expand it by default.
                if (!allowedNode.state) allowedNode.state = {};
                allowedNode.state.opened = true;
                
                data = [allowedNode];
            } else {
                // 2. Fallback: Try to find nodes by rootId (if parent node itself is missing but children exist)
                console.log('No single node found, trying rootId match...');
                
                function findNodesByRootId(nodes, id, result = []) {
                    if (!nodes || !Array.isArray(nodes)) return result;
                    for (const node of nodes) {
                        if (node.data && String(node.data.rootId) === id) {
                            result.push(node);
                        }
                        if (node.children && Array.isArray(node.children)) {
                            findNodesByRootId(node.children, id, result);
                        }
                    }
                    return result;
                }

                let filteredNodes = findNodesByRootId(data, permissionId);
                
                if (filteredNodes.length > 0) {
                    console.log('Found nodes by rootId:', filteredNodes.length);
                    data = filteredNodes;
                } else {
                    console.warn('Permission node not found in tree data:', permissionId);
                    data = []; 
                }
            }
        } else {
            console.log('No group_permission found for user, showing full tree.');
        }
    } else {
        console.warn('getUserInfo function not found!');
    }

    // Initialize sidebar tree
    // [PAGE-BLACKLIST] Kullanıcının engelli sayfalarını ağaçtan çıkar
    if (window.__pageBlacklistSet && window.__pageBlacklistSet.size > 0) {
      const before = JSON.stringify(data).length;
      data = pruneBlacklistedNodes(data);
      const after = JSON.stringify(data).length;
      console.log(`[PageBlacklist] Tree filtrelendi (${before} -> ${after} bayt)`);
    }

    // Check for sidebarTree first (as seen in index.html)
    const sidebarId = document.getElementById('sidebarTree') ? 'sidebarTree' : 'treeView';
    if (document.getElementById(sidebarId)) {
      console.log('Sidebar tree oluşturuluyor...');
      sidebarTree = new TreeView(sidebarId, data);
    } else {
      console.warn('Sidebar tree element (sidebarTree or treeView) not found');
    }
    
    // Initialize main content tree
    if (document.getElementById('mainTreeView')) {
      console.log('Main tree oluşturuluyor...');
      mainTree = new TreeView('mainTreeView', data);
    } else {
      // console.warn('mainTreeView elementi bulunamadı'); // Suppress warning if not needed
    }
  }
});

// Listen for tree item selection
document.addEventListener('treeItemSelected', function(e) {
  console.log('Tree item selected:', e.detail.item);
  // Burada seçilen öğe ile ilgili ek işlemler yapılabilir
});